import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="delivery">
      <Header />

      <main className="delivery__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">DELIVERY INFORMATION</span>
          </div>
        </div>

        <div className="delivery__container">
          <div className="delivery__content">
            {/* 页面标题 */}
            <section className="delivery__hero">
              <h1 className="delivery__title">DELIVERY INFORMATION</h1>
              <p className="delivery__subtitle">
                Fast, reliable shipping across Australia and internationally
              </p>
              <p className="delivery__updated">Last updated: January 2025</p>
            </section>

            {/* 配送选项概览 */}
            <section className="delivery__overview">
              <h2 className="section__title">Shipping Options</h2>
              <div className="shipping__options">
                <div className="shipping__option">
                  <div className="option__icon">
                    <i className="fas fa-truck"></i>
                  </div>
                  <div className="option__content">
                    <h3 className="option__title">Standard Shipping</h3>
                    <p className="option__price">$25.00</p>
                    <p className="option__time">5-7 business days</p>
                    <p className="option__desc">
                      Reliable delivery across Australia
                    </p>
                  </div>
                </div>
                <div className="shipping__option">
                  <div className="option__icon">
                    <i className="fas fa-shipping-fast"></i>
                  </div>
                  <div className="option__content">
                    <h3 className="option__title">Express Shipping</h3>
                    <p className="option__price">$35.00</p>
                    <p className="option__time">2-3 business days</p>
                    <p className="option__desc">
                      Faster delivery for urgent orders
                    </p>
                  </div>
                </div>
                <div className="shipping__option">
                  <div className="option__icon">
                    <i className="fas fa-gift"></i>
                  </div>
                  <div className="option__content">
                    <h3 className="option__title">Free Shipping</h3>
                    <p className="option__price">FREE</p>
                    <p className="option__time">5-7 business days</p>
                    <p className="option__desc">On orders over $249</p>
                  </div>
                </div>
                <div className="shipping__option">
                  <div className="option__icon">
                    <i className="fas fa-globe"></i>
                  </div>
                  <div className="option__content">
                    <h3 className="option__title">International</h3>
                    <p className="option__price">From $27.50</p>
                    <p className="option__time">7-21 business days</p>
                    <p className="option__desc">Worldwide delivery available</p>
                  </div>
                </div>
              </div>
            </section>

            {/* 详细配送信息 */}
            <div className="delivery__sections">
              <section className="delivery__section">
                <h2 className="section__title">Australian Shipping</h2>
                <div className="section__content">
                  <p className="section__text">
                    We offer fast and reliable shipping across all Australian
                    states and territories. All orders are processed within 1-2
                    business days and dispatched from our Sydney warehouse.
                  </p>

                  <h3 className="subsection__title">Shipping Rates:</h3>
                  <div className="shipping__rates">
                    <div className="rate__item">
                      <span className="rate__label">Orders under $249:</span>
                      <span className="rate__price">
                        $25.00 standard shipping
                      </span>
                    </div>
                    <div className="rate__item">
                      <span className="rate__label">Orders $249 and over:</span>
                      <span className="rate__price">
                        FREE standard shipping
                      </span>
                    </div>
                    <div className="rate__item">
                      <span className="rate__label">Express shipping:</span>
                      <span className="rate__price">
                        $35.00 (2-3 business days)
                      </span>
                    </div>
                  </div>

                  <h3 className="subsection__title">Delivery Areas:</h3>
                  <ul className="section__list">
                    <li>
                      All major cities: Sydney, Melbourne, Brisbane, Perth,
                      Adelaide, Canberra, Darwin, Hobart
                    </li>
                    <li>
                      Regional and rural areas (may require additional 1-2 days)
                    </li>
                    <li>
                      Remote locations (please contact us for delivery options)
                    </li>
                    <li>PO Box addresses accepted</li>
                  </ul>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">International Shipping</h2>
                <div className="section__content">
                  <p className="section__text">
                    We ship worldwide to over 200 countries and territories.
                    International shipping rates are calculated based on
                    destination, weight, and shipping method selected.
                  </p>

                  <h3 className="subsection__title">International Rates:</h3>
                  <div className="international__rates">
                    <div className="rate__zone">
                      <h4 className="zone__title">
                        Zone 1 - New Zealand, Pacific Islands
                      </h4>
                      <p className="zone__price">
                        From $27.50 (7-14 business days)
                      </p>
                    </div>
                    <div className="rate__zone">
                      <h4 className="zone__title">
                        Zone 2 - Asia, North America
                      </h4>
                      <p className="zone__price">
                        From $35.00 (10-18 business days)
                      </p>
                    </div>
                    <div className="rate__zone">
                      <h4 className="zone__title">
                        Zone 3 - Europe, South America
                      </h4>
                      <p className="zone__price">
                        From $42.50 (14-21 business days)
                      </p>
                    </div>
                    <div className="rate__zone">
                      <h4 className="zone__title">
                        Zone 4 - Africa, Middle East
                      </h4>
                      <p className="zone__price">
                        From $45.00 (14-21 business days)
                      </p>
                    </div>
                  </div>

                  <h3 className="subsection__title">Important Notes:</h3>
                  <ul className="section__list">
                    <li>
                      Customs duties and taxes may apply (customer
                      responsibility)
                    </li>
                    <li>Delivery times may vary due to customs processing</li>
                    <li>Some restrictions may apply to certain countries</li>
                    <li>
                      Tracking information provided for all international orders
                    </li>
                  </ul>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">Order Processing</h2>
                <div className="section__content">
                  <p className="section__text">
                    Orders are processed Monday through Friday during business
                    hours (9:30am - 4:00pm AEST). Orders placed after hours or
                    on weekends will be processed the next business day.
                  </p>

                  <h3 className="subsection__title">Processing Timeline:</h3>
                  <div className="processing__timeline">
                    <div className="timeline__item">
                      <div className="timeline__step">1</div>
                      <div className="timeline__content">
                        <h4 className="timeline__title">Order Received</h4>
                        <p className="timeline__desc">
                          Confirmation email sent immediately
                        </p>
                      </div>
                    </div>
                    <div className="timeline__item">
                      <div className="timeline__step">2</div>
                      <div className="timeline__content">
                        <h4 className="timeline__title">Payment Verified</h4>
                        <p className="timeline__desc">
                          Payment processed and verified
                        </p>
                      </div>
                    </div>
                    <div className="timeline__item">
                      <div className="timeline__step">3</div>
                      <div className="timeline__content">
                        <h4 className="timeline__title">Order Prepared</h4>
                        <p className="timeline__desc">
                          Items picked and packed (1-2 business days)
                        </p>
                      </div>
                    </div>
                    <div className="timeline__item">
                      <div className="timeline__step">4</div>
                      <div className="timeline__content">
                        <h4 className="timeline__title">Shipped</h4>
                        <p className="timeline__desc">
                          Tracking information emailed to you
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">Tracking Your Order</h2>
                <div className="section__content">
                  <p className="section__text">
                    Once your order is dispatched, you'll receive a tracking
                    number via email. You can use this number to track your
                    package's progress online.
                  </p>

                  <h3 className="subsection__title">
                    Tracking Information Includes:
                  </h3>
                  <ul className="section__list">
                    <li>Real-time location updates</li>
                    <li>Estimated delivery date</li>
                    <li>Delivery attempt notifications</li>
                    <li>Proof of delivery confirmation</li>
                  </ul>

                  <div className="tracking__info">
                    <div className="tracking__item">
                      <h4 className="tracking__title">Australia Post</h4>
                      <p className="tracking__desc">
                        Track at auspost.com.au with your tracking number
                      </p>
                    </div>
                    <div className="tracking__item">
                      <h4 className="tracking__title">
                        International Tracking
                      </h4>
                      <p className="tracking__desc">
                        Use provided tracking number on carrier's website
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">Delivery Issues</h2>
                <div className="section__content">
                  <p className="section__text">
                    If you experience any issues with your delivery, please
                    contact us immediately. We're here to help resolve any
                    problems quickly.
                  </p>

                  <h3 className="subsection__title">Common Issues:</h3>
                  <div className="issues__grid">
                    <div className="issue__item">
                      <h4 className="issue__title">Package Not Delivered</h4>
                      <p className="issue__desc">
                        Check with neighbors, building management, or local post
                        office. Contact us if still missing.
                      </p>
                    </div>
                    <div className="issue__item">
                      <h4 className="issue__title">Damaged Package</h4>
                      <p className="issue__desc">
                        Take photos of damage and contact us immediately for
                        replacement or refund.
                      </p>
                    </div>
                    <div className="issue__item">
                      <h4 className="issue__title">Wrong Address</h4>
                      <p className="issue__desc">
                        Contact us immediately if you provided incorrect address
                        information.
                      </p>
                    </div>
                    <div className="issue__item">
                      <h4 className="issue__title">Delayed Delivery</h4>
                      <p className="issue__desc">
                        Check tracking information. Contact us if significantly
                        delayed beyond estimated time.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">
                  Special Delivery Instructions
                </h2>
                <div className="section__content">
                  <p className="section__text">
                    We can accommodate special delivery instructions to ensure
                    your order reaches you safely.
                  </p>

                  <h3 className="subsection__title">Available Options:</h3>
                  <ul className="section__list">
                    <li>Authority to Leave (safe drop locations)</li>
                    <li>Delivery to workplace or alternative address</li>
                    <li>Signature required delivery</li>
                    <li>Hold at post office for collection</li>
                    <li>Specific delivery time requests (where available)</li>
                  </ul>

                  <p className="section__text">
                    Please include any special instructions in the order notes
                    during checkout, or contact us after placing your order.
                  </p>
                </div>
              </section>

              <section className="delivery__section">
                <h2 className="section__title">Contact Information</h2>
                <div className="section__content">
                  <p className="section__text">
                    For questions about shipping or to track your order, please
                    contact us:
                  </p>
                  <div className="contact__details">
                    <p>
                      <strong>Emeline Publications Australia</strong>
                    </p>
                    <p>Shipping Department</p>
                    <p>c/- Renniks Group Pty Ltd</p>
                    <p>Unit 6, 30 Perry Street</p>
                    <p>Matraville NSW 2036</p>
                    <p>
                      <strong>Business Hours:</strong> Monday - Friday, 9:30am
                      to 4:00pm AEST
                    </p>
                  </div>
                </div>
              </section>
            </div>

            {/* 相关链接 */}
            <section className="delivery__links">
              <h2 className="section__title">Related Information</h2>
              <div className="policy__links">
                <Link to="/returns" onClick={toTop} className="policy__link">
                  Returns Policy
                </Link>
                <Link to="/terms" onClick={toTop} className="policy__link">
                  Terms & Conditions
                </Link>
                <Link to="/contact" onClick={toTop} className="policy__link">
                  Contact Us
                </Link>
                <Link to="/shop" onClick={toTop} className="policy__link">
                  Start Shopping
                </Link>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Delivery;
